<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请选择">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in typeList" :key="index"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "OrderState",
    props: ["value"],
    watch: {
      value: {
        immediate: true,
        handler: function(value) {
          this.data = value;
        }

      },

    },
    data() {
      return {
        data: "",
        typeList: [{
            name: "未出库",
            value: "1"
          },
          {
            name: "已出库",
            value: "3"
          },
          {
            name: "部分出库",
            value: "2"
          },
        ]
      }
    },
    methods: {
      handleChange(value) {
        this.data = value;
        this.$emit("input", value)
      }
    }
  }
</script>

<style scoped>

</style>
